import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { appLoginPath, LANDING_PATHS } from "@/lib/landingPaths";
import SiteLogo from "@/components/SiteLogo";
import { scrollToId } from "./formatCurrency";

const NAV_LINKS = [
  { label: "How It Works", id: "how-it-works" },
  { label: "ROI Calculator", id: "roi-calculator" },
  { label: "Live Sandbox", id: "sandbox" },
  { label: "Pricing", id: "tiers" },
  { label: "Apply", id: "partner-form" },
];

const navLinkClass =
  "text-partner-muted hover:text-partner transition-colors text-xs lg:text-sm font-medium whitespace-nowrap";

const PartnerNavbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (event, id) => {
    event.preventDefault();
    scrollToId(id);
  };

  return (
    <motion.nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#080A0F]/75 backdrop-blur-md backdrop-saturate-150"
          : "bg-transparent"
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      data-testid="partner-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 gap-4">
          <Link to={LANDING_PATHS.partner} className="flex items-center shrink-0" data-testid="partner-logo">
            <SiteLogo className="w-full max-w-[120px]" />
          </Link>

          <div className="hidden md:flex items-center gap-4 lg:gap-6 xl:gap-8 min-w-0">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(event) => handleNavClick(event, link.id)}
                className={navLinkClass}
              >
                {link.label}
              </a>
            ))}
            <Link to={appLoginPath()} className={navLinkClass}>
              Login
            </Link>
          </div>

          <div className="hidden xl:block shrink-0">
            <span className="badge-mono text-partner-accent">PARTNER INFRASTRUCTURE</span>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default PartnerNavbar;
